/**
 * A small emoji for each question's theme.
 *
 * Presentation only — this deliberately lives outside `james.questions.ts` so
 * that the questions, the answers and the scoring stay exactly what James
 * wrote. Nothing here changes a word of the content; it only gives the badge
 * at the top of each question a face.
 *
 * Keyed by question id rather than by theme string so that rewording a theme
 * never silently drops its badge. Anything unmapped falls back to a neutral
 * speech mark, so a new question is never broken, just plainer.
 */
export const THEME_EMOJI: Record<string, string> = {
  // Round one - the foundations
  'nights-out': '\u{1F319}', // 🌙 Friday night
  'social-life': '\u{1F5E3}️', // 🗣️ social rhythm
  fitness: '\u{1F3C3}', // 🏃 health and fitness
  diet: '\u{1F957}', // 🥗 food
  'weekend-together': '\u{1F5FA}️', // 🗺️ a weekend together
  affection: '\u{1F49E}', // 💞 affection
  independence: '\u{1F9E9}', // 🧩 two pieces, still two pieces
  intentions: '\u{1F9ED}', // 🧭 the big picture
  children: '\u{1F3E1}', // 🏡 family
  monogamy: '\u{1F91D}', // 🤝 commitment

  // Round two - the everyday
  'good-saturday': '☕', // ☕ a day of your own
  'relationship-adds': '\u{1F331}', // 🌱 what a relationship grows
  conflict: '\u{1F6E0}️', // 🛠️ repair
  care: '\u{1FAC2}', // 🫂 warmth
  substances: '\u{1F375}', // 🍵 everyday lifestyle
  'home-and-animals': '\u{1F408}', // 🐈 the cat, specifically
  humour: '\u{1F604}', // 😄 playfulness
};

export const DEFAULT_THEME_EMOJI = '\u{1F4AC}'; // 💬

export function themeEmoji(questionId: string): string {
  return THEME_EMOJI[questionId] ?? DEFAULT_THEME_EMOJI;
}
